import { useState, useEffect } from "react";
import arrowRight from "../../../Assets/images/arrow-right.svg";
import mailIcon from "../../../Assets/images/mail.svg";
import { useNavigate } from "react-router-dom";
import { sendUpdatedEmail } from "../../../Services/settingsServices";
import Loader from "react-js-loader";

function EmailSettingsScreen2({ onUpdateEmailClick, currentEmail }) {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();


   useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage("");
      }, 3000); // 3000 ms = 3 seconds

      return () => clearTimeout(timer); // cleanup on unmount or error change
    }
  }, [errorMessage]);


  const onUpdateEmail = async () => {
    if (isLoading) return; // Prevent multiple clicks
    setIsLoading(true);
    setErrorMessage(""); // Reset previous errors

    if (!email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)) {
      setErrorMessage("Invalid email format.");
      setIsLoading(false);
      return;
    }

    if (email === currentEmail) {
      setErrorMessage("New email cannot be the same as the current email.");
      setIsLoading(false);
      return;
    } else {
      try {
        const response = await sendUpdatedEmail(email.toLowerCase());
        const ok = response?.payload?.success || response?.status === "success" || response?.status === 200;
        if (ok) {
          setSuccessMessage("Email sent successfully!");
          sessionStorage.setItem("updatedEmail", email.toLowerCase());
          onUpdateEmailClick();
        } else if (response?.status === 422) {
          setErrorMessage(response?.message || response?.mesage || "Unable to send code. Please try again.");
        } else {
          throw new Error(response?.message || "Failed to update email.");
        }
      } catch (error) {
        setErrorMessage(error?.response?.data?.message || error?.response?.data?.mesage || error?.message || "Something went wrong !");
      } finally {
        setIsLoading(false); // Reset button state
      }
    }
  };

  return (
    <div className="set-phone-modal-container">
      {isLoading && (
        <div className="loader-df-container">
          <Loader
            type="spinner-cub"
            bgColor={"#2D50A7"}
            color={"#3D6DEB"}
            size={45}
          />
        </div>
      )}
      <div>
        <div className="set-phone-modal-head">Edit Email</div>
        <div className="set-phone-modal-support">
          Update the email associated with your account.
        </div>
      </div>
      <div className="set-phone-int-cnt" style={{ marginBottom: "10px" }}>
        <div className="set-phone-modal-input-container">
          <div className="set-phone-input-label">Email</div>
          <div className="mobile-input-wrapper" onClick={(e) => e.stopPropagation()}>
            <span className="set-email-icon">
              <img src={mailIcon} alt="mail" />
            </span>
            <input
              type="email"
              className="mobile-input"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        </div>
        {errorMessage && (
          <div
            style={{
              color: "red",
              textAlign: "center",
            }}
          >
            {errorMessage}
          </div>
        )}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "20px",
            marginTop: "20px",
          }}
        >
          <button
            className="set-phone-continue-button"
            onClick={onUpdateEmail}
            style={{
              cursor: isLoading ? "not-allowed" : "pointer",
              opacity: isLoading ? "0.6" : "1",
            }}
          >
            Continue <img src={arrowRight} alt="continue" />
          </button>
        </div>

        {successMessage && (
          <div
            style={{
              color: "green",
              textAlign: "center",
            }}
          >
            {successMessage}
          </div>
        )}
      </div>
    </div>
  );
}

export default EmailSettingsScreen2;
